function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from "react";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useDeviceDetect from "../../../hooks/useDeviceDetect";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "m20.727 16.693-6.034 6.02a.997.997 0 0 1-1.4 0 .98.98 0 0 1 0-1.386L18.643 16l-5.34-5.326a.98.98 0 0 1 0-1.386.997.997 0 0 1 1.4 0l6.034 6.02a.974.974 0 0 1 0 1.386z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32"
};
import { spaceFactor } from "../../../utils/space";
import { StyledArrow, StyledSlider } from "./ItemsSliderContainerOrg.styled";
function ItemsSliderContainerOrg(_ref) {
  var items = _ref.items,
    maxItemsToShow = _ref.maxItemsToShow,
    itemMinWidthSpace = _ref.itemMinWidthSpace,
    gapSpace = _ref.gapSpace;
  var containerRef = useRef(null);
  var _useState = useState(maxItemsToShow),
    _useState2 = _slicedToArray(_useState, 2),
    visibleItemsNumber = _useState2[0],
    setVisibleItemsNumber = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentSlideNumber = _useState4[0],
    setCurrentSlideNumber = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isArrowShow = _useState6[0],
    setIsArrowShow = _useState6[1];
  var isDesktopSize = useBreakpoint("large");
  var _useDeviceDetect = useDeviceDetect(),
    isDesktop = _useDeviceDetect.isDesktop;
  var itemsLength = items.length;
  var checkVisibleItemsAndArrowShow = function checkVisibleItemsAndArrowShow() {
    var _containerRef$current;
    var containerWidth = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth;
    if (!containerWidth) {
      return;
    }
    var itemWidth = itemMinWidthSpace * spaceFactor;
    var marginWidth = gapSpace * spaceFactor;
    var visibleItems = Math.floor((containerWidth + marginWidth) / (itemWidth + marginWidth));
    var allItemsWithMarginsWidth = itemsLength * itemWidth + (itemsLength - 1) * marginWidth;
    if (allItemsWithMarginsWidth > containerWidth) {
      setIsArrowShow(true);
    } else {
      setIsArrowShow(false);
    }
    setVisibleItemsNumber(visibleItems);
  };
  var commonSliderParameters = {
    infinite: false,
    draggable: false,
    useTransform: false,
    prevArrow: /*#__PURE__*/React.createElement(StyledArrow, {
      $isPrevIcon: true
    }, /*#__PURE__*/React.createElement(ArrowSvg, null)),
    nextArrow: /*#__PURE__*/React.createElement(StyledArrow, null, /*#__PURE__*/React.createElement(ArrowSvg, null))
  };
  useEffect(function () {
    checkVisibleItemsAndArrowShow();
    window.addEventListener("resize", checkVisibleItemsAndArrowShow);
    return function () {
      window.removeEventListener("resize", checkVisibleItemsAndArrowShow);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(StyledSlider, _extends({}, commonSliderParameters, {
    arrows: !!(isDesktop && isArrowShow),
    slidesToShow: visibleItemsNumber,
    slidesToScroll: 1,
    $gapSpace: gapSpace,
    $itemMinWidthSpace: itemMinWidthSpace,
    $hasExpandedItems: !isArrowShow,
    $currentSlideNumber: currentSlideNumber,
    variableWidth: !isDesktopSize || itemsLength > maxItemsToShow,
    beforeChange: function beforeChange(_, nextSlide) {
      return setCurrentSlideNumber(nextSlide);
    }
  }), items));
}
export default ItemsSliderContainerOrg;